import { getJwtToken } from "../getJwtToken";
import { fetchKycToken } from "./fetchKycToken";

export const sumsubTokenExpirationHandler = async (): Promise<string> => {
  const token: string = await getJwtToken();
  return fetchKycToken(token);
};
